export default {
    url: '/role',
    template: '<user-group-list-role/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/list/role/index.js